import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import {
  EmailEventService,
  EmailEvent,
  EmailMessage,
  EventType,
  PagedRequestOptions,
  ListEmailEventsResponse,
} from '@vendasta/email';
import { switchMap, takeUntil } from 'rxjs/operators';
import { SiteService } from '../../../core/site';

@Component({
  selector: 'app-partner-email-preview',
  templateUrl: './partner-email-preview.component.html',
  styleUrls: ['./partner-email-preview.component.scss'],
  standalone: false,
})
export class PartnerEmailPreviewComponent implements OnInit, OnDestroy {
  email: EmailMessage;
  events$: Observable<EmailEvent[]>;
  private _events$$: BehaviorSubject<EmailEvent[]> = new BehaviorSubject<EmailEvent[]>([]);
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private _eventService: EmailEventService,
    private _siteService: SiteService,
    public dialogRef: MatDialogRef<PartnerEmailPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) private _email: EmailMessage,
  ) {
    this.email = _email;
  }

  ngOnInit(): void {
    const po = new PagedRequestOptions({ cursor: '', pageSize: 10 });
    this.events$ = this._events$$.asObservable();
    this._siteService.site$
      .pipe(
        switchMap((site) => this._eventService.listEvents(this.email.emailId, po, site.partnerId, site.accountId)),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe((res: ListEmailEventsResponse) => {
        this._events$$.next(res.events);
      });
  }

  eventTypeToString(e: EventType): string {
    return EventType[e];
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
